export default __webpack_public_path__ + "static/char-v-10-jam-bba890e40d3f6c35203c39812e121832.mp4";